export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'defaultImageUrl',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 80,
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_displayName') || '产品名称',
    field: 'displayName',
    minWidth: 220,
    fixed: 'left',
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_displaySpec') || '颜色尺寸',
    field: 'displaySpec',
    minWidth: 180,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySpec' },
  },
  {
    title: that.$l('table_label_displayNo') || '产品编号',
    field: 'displayNo',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayNo' },
  },
  {
    title: that.$l('table_label_stockOutDays') || '断货天数',
    field: 'stockOutDays',
    minWidth: 90,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_stockOutPeriod1') || '断货周期1',
    field: 'stockOutPeriod1',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_stockOutPeriod2') || '断货周期2',
    field: 'stockOutPeriod2',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_stockOutPeriod3') || '断货周期3',
    field: 'stockOutPeriod3',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_stockOutPeriod4') || '断货周期4',
    field: 'stockOutPeriod4',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_stockOutPeriod5') || '断货周期5',
    field: 'stockOutPeriod5',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
  },
]
